<template>
  <div class="copyDesc">
      <div class="title">{{title}}</div>
      <div class="content" >
          <div v-for="(item,index) in orderList" :key="index">
            <p class="tips">{{item.label}}</p>
            <p class="desc">{{item.desc}}<span v-if="htmlTag" v-html="htmlTag"></span></p>
            
            
          </div>
      </div>
  </div>
</template>

<script>
export default {
data(){
return{
    desc:'<a href="https://www.yuque.com/dongtiandeyinghuochong/qtw9rm/hm1gkq">'+this.$t('other.a2188')+'</a>'
}
},
props:{
    title:{
        type:String,
        default:''
    },
    orderList:{
        type:Array,
        default:() => {}
    },
    htmlTag:{
        type:String,
        default:''
    },

},
create(){

},
methods:{

}
}

</script>
<style lang="scss" scoped>
.copyDesc{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .title{
        font-size: 25px;
        font-weight: 600;
    }

    .tips{
        margin: 10px 0;
        font-weight: bold;
        
    }
    .desc{
        width:80%;
        padding-left: 20px;
    }

    .content{
        padding-left: 100px;
        font-size: 16px;
        color: rgba(0,0,0,.9);
    }


}
</style>